/// <reference path="../../../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />
import * as React from 'react';
import { Dialog, DialogFooter, Label } from 'office-ui-fabric-react';
import type { IDialogProps, IDialogFooterProps } from 'office-ui-fabric-react';
import { AppButton } from '../AppButton';
import { getTopLabelStyles, getModalProps, getDialogContentProps, getDialogStyles } from '../../common/styles/Popup.styles';
import { AppLayoutSettings } from '../../common/styles/common.styles';
import { AppAuthenticationProviderContext } from '../../context';
import { IAuthenticationProvider } from '../../../backend/interfaces/IAuthenticationProvider';
import { ILogEvent } from '../../../backend/interfaces/ILogEvent';
import { AuthPopupKeys } from '../../common/telemetry/AuthPopupKeys';
import { LogEventNames } from '../../../backend/interfaces/ITelemetryLogger';
import { LogEvent } from '../../../backend/TelemetryLogger/LogEvent';
import { ErrorStringFromException, isNullOrUndefined } from '../../../utils/utils';

const DialogWithChildren = Dialog as React.FunctionComponent<React.PropsWithChildren<IDialogProps>>;
const DialogFooterWithChildren = DialogFooter as React.FunctionComponent<React.PropsWithChildren<IDialogFooterProps>>

interface AuthPopupState {
  isUserInteractionNeeded: boolean
}

export class AuthPopup extends React.PureComponent<{}, AuthPopupState> {
  declare context: React.ContextType<typeof AppAuthenticationProviderContext>
  static contextType = AppAuthenticationProviderContext;
  private resolveCallback: ((value?: any) => void) | null = null;
  private rejectCallback: ((reason?: any) => void) | null = null;
  private getAccessToken: (() => Promise<any>) | null = null;

  constructor(props: {}) {
    super(props);

    this.state = {
      isUserInteractionNeeded: false
    };
  }

  public componentDidMount() {
    const authProvider: IAuthenticationProvider | null = this.context;
    if (isNullOrUndefined(authProvider)) {
      return;
    }
    authProvider!.SetUIAuthProvider((getAccessToken: () => Promise<any>) => {
      this.getAccessToken = getAccessToken;
      this.setState({ isUserInteractionNeeded: true });
      return new Promise<any>((resolve, reject) => {
        this.resolveCallback = resolve;
        this.rejectCallback = reject;
      });
    });
  }

  private async onExecute() {
    const AuthPopupTelemetry: ILogEvent<AuthPopupKeys> = new LogEvent<AuthPopupKeys>(LogEventNames.AuthPopup);
    AuthPopupTelemetry.Start();
    try {
      const token = await this.getAccessToken!();
      AuthPopupTelemetry.End([{ key: AuthPopupKeys.AuthPopupSuccess, value: true }]);
      this.setState({ isUserInteractionNeeded: false });
      this.resolveCallback!(token);
    } catch (e) {
      AuthPopupTelemetry.End([{ key: AuthPopupKeys.AuthPopupSuccess, value: false }, { key: AuthPopupKeys.AuthPopupFailureReason, value: ErrorStringFromException(e) }]);
      this.setState({ isUserInteractionNeeded: false });
      this.rejectCallback!(e);
    }
  }

  public render() {
    if (!this.state.isUserInteractionNeeded) {
      return null;
    } else {
      const title: string | JSX.Element =
        <Label styles={ getTopLabelStyles() }>
          { TranscriptionStrings.AuthPopupTitleLabel }
        </Label>

      return (
        <DialogWithChildren
          dialogContentProps={ getDialogContentProps(title) }
          modalProps={ getModalProps() }
          hidden={ !this.state.isUserInteractionNeeded }
          onDismiss={ () => this.rejectCallback!("User dismissed AuthPopup") }
          styles={ getDialogStyles() }
        >
          <Label styles={ AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles() }>{ TranscriptionStrings.AuthPopupBodyLabel }</Label>
          <DialogFooterWithChildren>
            <AppButton
              type={ 'AppButtonProps' }
              id="VerifyButton"
              text={ TranscriptionStrings.AuthPopupButtonLabel }
              onExecute={ () => this.onExecute() }
            />
          </DialogFooterWithChildren>
        </DialogWithChildren>
      );
    }
  }
}